import React from "react";

const BareLayout = ({ children }) => <>{children}</>;

export default BareLayout;
